import BaseNode from './BaseNode';
import AirOutlinedIcon from '@mui/icons-material/AirOutlined';
import { colors } from '../../styles';

const FlowNode = ({ data }: { data: { label: string } }) => (
  <BaseNode label={data.label} typeLabel="Subfluxo" accent={colors.brand.textStrong} icon={<AirOutlinedIcon />} />
);

export default FlowNode;
